import {
    FilesUpdateRequest,
    IPictureFileMetadataResponse,
    PictureFileMetadataResponse,
} from '@kcftech/prometheustypescriptapiclient';
import { QueryObserverResult } from '@tanstack/react-query';
import { TextInlineEditor } from 'components/inline_edit/TextInlineEditor';
import { sdClient } from 'contexts/SDKClientContext';

// See Prometheus' Shared.PrometheusConstants.MaxUploadFilenameLength
const maxNameLength = 223;

const validate = (val: string | undefined) => {
    if (val && val.length > maxNameLength) {
        return `Name must be ${maxNameLength} characters or less`;
    }
    return undefined;
};

export type FileDetailsNameProps = Readonly<{
    file: IPictureFileMetadataResponse;
    canEdit: boolean;
    refetchFile: () => Promise<
        QueryObserverResult<PictureFileMetadataResponse | undefined, unknown>
    >;
    refreshTable: () => void;
}>;

export function FileDetailsNameEditor({
    file,
    canEdit,
    refetchFile,
    refreshTable,
}: FileDetailsNameProps) {
    const onConfirm = async (updatedName: string | undefined) => {
        if (!updatedName) {
            throw new Error('Attempted to save a file without a name');
        }
        try {
            await sdClient
                .updateFile({
                    fileId: file.Id,
                    body: new FilesUpdateRequest({
                        DisplayName: updatedName,
                        ParentFolderId: file.ParentFolderId ?? '',
                        Description: file.Description,
                        GroupIds: file.GroupIds,
                    }),
                })
                .then(refetchFile)
                .then(refreshTable);
        } catch {
            return 'Unable to save name for File';
        }
        return undefined;
    };

    return (
        <TextInlineEditor
            valueClass="word-break"
            editorStyle={{ width: '50rem' }}
            isDisabled={!canEdit}
            value={file.DisplayName}
            validate={validate}
            onConfirm={onConfirm}
        />
    );
}
